import(/* webpackMode: "eager" */ "/app/components/FAQ/index.tsx");
import(/* webpackMode: "eager" */ "/app/app/coins/[coin]/page.module.scss");
import(/* webpackMode: "eager" */ "/app/components/coins/single/Content/style.module.scss");
import(/* webpackMode: "eager" */ "/app/components/coins/single/Overview/index.tsx")